if (!customElements.get('snow-cart-progress')) {
  customElements.define('snow-cart-progress', class extends HTMLElement {
    connectedCallback() {
      this.onCartUpdated = (event) => {
        const cart = event.detail?.cart;
        if (!Array.isArray(cart?.items)) return;
        const pieces = cart.items.reduce((count, item) => count + (item.requires_shipping && !item.gift_card ? item.quantity : 0), 0);
        const excludedTotal = cart.items.reduce((total, item) => total + (!item.requires_shipping || item.gift_card ? item.final_line_price : 0), 0);
        const applications = [
          ...(cart.cart_level_discount_applications || []),
          ...cart.items.flatMap((item) => (item.line_level_discount_allocations || []).map((allocation) => allocation.discount_application)),
        ];
        const hasDiscountCode = (cart.discount_codes || []).some((discount) => discount.applicable === true)
          || applications.some((application) => application?.type === 'discount_code');
        this.update(Math.max(0, cart.total_price - excludedTotal), pieces, cart.currency, hasDiscountCode);
      };
      document.addEventListener('cart:updated', this.onCartUpdated);
      this.update(Number(this.dataset.total), Number(this.dataset.pieces), this.dataset.currency, this.dataset.hasDiscountCode === 'true');
    }

    disconnectedCallback() {
      document.removeEventListener('cart:updated', this.onCartUpdated);
    }

    update(total, pieces, currency, hasDiscountCode = false) {
      const activeCurrency = window.Shopify?.currency?.active || this.dataset.currency;
      const rate = activeCurrency === 'USD' ? 1 : Number(window.Shopify?.currency?.rate);
      if (currency !== activeCurrency || !Number.isFinite(rate) || rate <= 0) {
        this.hidden = true;
        return;
      }
      const threshold = Math.round(Number(this.dataset.threshold) * rate);
      const remaining = Math.max(0, threshold - total);
      const percentage = Math.min(100, Math.max(0, total / threshold * 100));
      const shippingBar = this.querySelector('[data-shipping-bar]');
      shippingBar.setAttribute('aria-valuenow', String(Math.round(percentage)));
      shippingBar.firstElementChild.style.width = `${percentage}%`;
      this.querySelector('[data-shipping-remaining]').hidden = remaining === 0;
      this.querySelector('[data-shipping-ready]').hidden = remaining > 0;
      const amount = this.querySelector('[data-remaining]');
      try {
        amount.textContent = new Intl.NumberFormat(document.documentElement.lang || 'en', { style: 'currency', currency, minimumFractionDigits: 2, maximumFractionDigits: 2 }).format(remaining / 100);
      } catch {
        amount.textContent = `${(remaining / 100).toFixed(2)} ${currency}`;
      }
      const savings = this.querySelector('[data-savings]');
      savings.hidden = pieces === 0;
      savings.classList.toggle('is-available', hasDiscountCode);
      this.querySelector('[data-savings-pending]').hidden = pieces >= 2 || hasDiscountCode;
      this.querySelector('[data-savings-ready]').hidden = pieces < 2 || hasDiscountCode;
      this.querySelector('[data-savings-available]').hidden = !hasDiscountCode;
      this.querySelector('[data-savings-check]').hidden = hasDiscountCode;
      const savingsBar = this.querySelector('[data-savings-bar]');
      savingsBar.setAttribute('aria-valuenow', String(Math.min(2, pieces)));
      savingsBar.firstElementChild.style.width = `${Math.min(2, pieces) * 50}%`;
      this.querySelector('[data-savings-dot]').classList.toggle('is-complete', pieces >= 2);
      this.querySelector('.snow-cart-progress__milestone').classList.toggle('is-complete', pieces >= 2);
      this.hidden = false;
    }
  });
}
